import { GeoFilterNames } from '../../../../utils/enums';
import { CountryWithStatus } from '../../../../dtos/country-with-status.dto';
import { FilterConfig } from '../../../../model/filter';

export const countryFiltersConfig: FilterConfig<CountryWithStatus> = {
    searchBox: { placeholder: 'Search Country', byFields: ['countryName'] },
    localStorageKey: 'geoDefaultFilter',
    radioButtons: {
        defaultSelectionIndex: 0,
        options: [
            { label: GeoFilterNames.All, filterFn: () => true },
            { label: GeoFilterNames.Blocked, filterFn: (countryDto: CountryWithStatus) => !countryDto.isInboundAllow || !countryDto.isOutboundAllow },
            { label: GeoFilterNames.Allowed, filterFn: (countryDto: CountryWithStatus) => countryDto.isInboundAllow || countryDto.isOutboundAllow },
            { label: GeoFilterNames.HighRiskCountries, filterFn: (countryDto: CountryWithStatus) => countryDto.highRisk }
        ]
    },
};